import React, { useState, useEffect } from "react";
import { Button, Alert, AlertTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import { View } from '@instructure/ui-view'

function ConfirmationDialogRaw(props) {
  const { onClose, onOk, open, message, ...other } = props;
  const radioGroupRef = React.useRef(null);
  const [newPassword, setNewPassword] = React.useState(null);
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    if (newPassword.length >= 8) {
      onOk(newPassword);
    } else {
      setError(true);
      setHelperText("Vui lòng nhập mật khẩu trên 8 ký tự")
    }
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle>Thông báo</DialogTitle>
      <DialogContent dividers>
      {message} với mật khẩu là:
      <View as="div" padding="small">
        <TextField
          error={error}
          id="new-password"
          label="Mật khẩu mới"
          value={newPassword}
          helperText={helperText}
          sx={{
            width: "100%"
          }}
          onChange={(event) => {
            setNewPassword(event.target.value);
          }}
        />
      </View>
      
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Hủy bỏ
        </Button>
        <Button onClick={handleOk}>Xác nhận</Button>
      </DialogActions>
    </Dialog>
  );
}

function ConfirmationDialogSync(props) {
  const { onClose, onOk, open, message, ...other } = props;
  const radioGroupRef = React.useRef(null);
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onOk();
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle>Thông báo</DialogTitle>
      <DialogContent dividers>
      {message} 
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Hủy bỏ
        </Button>
        <Button onClick={handleOk}>Xác nhận</Button>
      </DialogActions>
    </Dialog>
  );
}

export function ResetButton({
  selectedIds,
  setSelectedIds,
  disableButton,
  type,
  selectedClass,
  setIsReset,
}) {
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [loadingSync, setLoadingSync] = React.useState(false);
  const [openComfirm, setOpenConfirm] = React.useState(false);
  const [progress, setProgress] = React.useState("");
  const [openComfirmSync, setOpenConfirmSync] = React.useState(false);

  const handleClickListItem = () => {
    setOpenConfirm(true);
  };

  const handleClose = (newValue) => {
    setOpenConfirm(false);
  };

  const handleOk = (newPassword) => {
    setLoading(true);
    setOpenConfirm(false);
    const query =
      type === "student"
        ? "/api/v1/moet/students/reset"
        : "/api/v1/moet/parents/reset";

    fetch(query, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem(
          "token"
        )}`,
      },
      body: JSON.stringify({
        studentIds: selectedIds,
        newPassword: newPassword
      }),
    })
      .then((response) => {
        if (!response.ok) {
          // If the response status is not 200-299, handle the error
          throw new Error(
            `HTTP error! Status: ${response.status}`
          );
        }
        setSeverity("success");
        setIsReset(true);
        return response.json();
      })
      .then((data) => {
        if (data) {
          setOpen(true);
          setMessage("Mật khẩu đã được đặt lại");
          setSelectedIds([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        // console.error('Error:',error);
        setSeverity("error");
        setOpen(true);
        setLoading(false);
        setMessage("Không thể đặt lại mật khẩu");
      });
  }

  const handleClickSync = () => {
    setOpenConfirmSync(true);
  }

  const handleCloseSync = (newValue) => {
    setOpenConfirmSync(false);
  };


  const intervalSyncStatus = () => {
    const interval = setInterval(() => {
      fetch(`/api/v1/moet/sync`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${window.localStorage.getItem(
            "token"
          )}`,
        }
      })
      .then(res => res.json())
      .then(data => {
        if (['pedning', 'processing'].includes(data.workflow_state)) {
          setLoadingSync(true);
          setProgress(data.progress);
        } else {
          setLoadingSync(false);
          setProgress("");
          clearInterval(interval);
        }
      })
      .catch(err => {
        setLoadingSync(false);
        setProgress("");
        console.error("Error fetching job progress:", err);
      });
    }, 5000);
    return () => clearInterval(interval); 
  }

  const handleOkSync = () => {
    setLoadingSync(true);
    setOpenConfirmSync(false);
    fetch('/api/v1/moet/sync', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem(
          "token"
        )}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          // If the response status is not 200-299, handle the error
          throw new Error(
            `HTTP error! Status: ${response.status}`
          );
        }
        setSeverity("success");
        setIsReset(true);
        return response.json();
      })
      .then((data) => {
        if (data) {
          setOpen(true);
          setMessage("Các tài khoản đang được đồng bộ");
          setLoadingSync(false);
          setProgress("0");
          intervalSyncStatus();
        }
        setLoadingSync(false);
      })
      .catch((error) => {
        // console.error('Error:',error);
        setSeverity("error");
        setOpen(true);
        setLoadingSync(false);
        setMessage("Không thể đồng bộ được tài khoản. Vui lòng thử lại sau");
      });
  }

  useEffect(() => {
    intervalSyncStatus();
  }, []);

  return (
    <>
      {open && (
        <Alert
          severity={severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
                setMessage("");
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle>Thông báo</AlertTitle>
          {message}
        </Alert>
      )}
      <ConfirmationDialogRaw
          id="confirm-reset"
          keepMounted
          open={openComfirm}
          message={`Xác nhận thay đổi mật khẩu cho các tài khoản  ${type == 'student' ? "học sinh" : "phụ huynh"} đã chọn`}
          onOk={handleOk}
          onClose={handleClose}
        />
      <ConfirmationDialogSync
        id="confirm-sync"
        keepMounted
        open={openComfirmSync}
        message={`Xác nhận đồng bộ tài khoản từ CSDL Ngành`}
        onOk={handleOkSync}
        onClose={handleCloseSync}
      />
      {disableButton ? (
        <LoadingButton
          variant="contained"
          // size="small"
          disabled
        >
          Đặt lại mật khẩu
        </LoadingButton>
      ) : (
        <LoadingButton
          variant="contained"
          // size="small"
          loading={loading}
          onClick={handleClickListItem}
        >
          Đặt lại mật khẩu
        </LoadingButton>
      )}
      <LoadingButton
          variant="contained"
          // size="small"
          loading={loadingSync}
          onClick={handleClickSync}
        >
          Đồng bộ tài khoản mới
        </LoadingButton>
        {loadingSync ? `Tiến độ đồng bộ: ${progress}` : ""}
    </>
  );
}
